import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const FundraisingDealStructuring = () => {
  const serviceData = {
    title: "Fundraising & Deal Structuring",
    heading: "Fundraising & Deal Structuring",
    image: subTopicImages["Fundraising & Deal Structuring"],
    intro:
      "Supporting capital raising with compliant and efficient structuring",
    description: [
      "We assist promoters, companies and investors in structuring transactions and capital raising in a manner that is financially efficient, commercially suitable and compliant with Indian regulations.",
    ],
    services: [
      {
        title: "Our Role Includes",
        list: [
          "transaction feasibility & structuring options",
          "evaluation of equity, debt & hybrid instruments",
          "tax & regulatory considerations",
          "shareholder & capital structuring",
          "support during negotiations & documentation review",
          "coordination with legal & banking advisors",
        ],
        extraInfo:
          "Our advice is independent and practical, aimed at helping clients achieve the right balance between control, valuation, compliance and funding needs.",
      },
    ],
    benefitsIntro: "",
    benefits: [],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default FundraisingDealStructuring;
